export default __webpack_public_path__ + "static/media/Raleway-Medium.0de59257.ttf";